import { toast, ToastOptions } from 'react-toastify'

export const showToast = (message: string, options?: ToastOptions) => {
  toast(
    message || 'Success',
    options || {
      autoClose: 5000,
      closeOnClick: true,
      draggable: true,
      hideProgressBar: false,
      pauseOnHover: true,
      position: 'top-right',
      theme: 'light'
    }
  )
}
